var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { staticClass: "brand-filter-item", attrs: { href: _vm.link } },
    [
      _c(
        "div",
        { staticClass: "item-content" },
        [
          _vm.hasLogo
            ? _c("el-image", {
                staticClass: "brand-image",
                attrs: { src: _vm.logo, fit: "contain", alt: _vm.title },
              })
            : _c("div", { staticClass: "brand-no-image" }, [
                _vm._v(_vm._s(_vm.title) + "\n        "),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasUnreadMessages
        ? _c("div", { staticClass: "unread-stats" }, [
            _c(
              "span",
              { staticClass: "badge badge-danger badge-smaller badge-pill" },
              [_vm._v(_vm._s(_vm.unreadMessages))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }